const IN_METRES = ["delivery_radius", "free_delivery_radius"];

export const settingLabel = (paramName) => {
  const words = paramName.replaceAll("_", " ");
  return IN_METRES.includes(paramName) ? `${words} (metres)` : words;
};
